<template>
    <div class="address-list-item">
        <div class="font-weight-bold">{{address.addressName}}</div>
        <div class="font-weight-bold">
            {{address.firstname}} {{address.lastname}}
        </div>
        <div>
            {{address.address}}
            {{address.subDistrictName}}
            {{address.districtName}}
            {{address.provinceName}}
            {{address.zipcode}}
        </div>
        <div>
            <button class="btn btn-sm btn-success mr-2" @click="onEditAddress()">Edit</button>
            <button class="btn btn-sm btn-danger" @click="onDeleteAddress()">Delete</button>
        </div>
    </div>
</template>
<script>

/**
 * @event onDeleteSuccess
 */
export default {
    name: "AddressListItem",
    props: {
        address: Object,
    },
    methods: {
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
    },
}
</script>
<style lang="scss" scoped>
    .address-list-item {
        border-top: 1px solid #ccc;
        padding: 10px 10px;

        &:last-child {
            border-bottom: 1px solid #ccc;
        }
    }
</style>
